<template>
  <div class="introduce-page">
    <img class="banner"  src="@/assets/images/introduce/introduce-banner.png" alt="">
    <div class="main download-page" >
      <div  class="title" style=" margin-top: 2vw;">博智林机器人联合APP</div>
        <div>
            <div>
                <a href="https://warehouse.bzlrobot.com/application/download/download.html?id=192036">
                    <div class="download-btn">点击下载</div>
                </a>
                <p class="download-text">
                    支持Android9.0及以上版本
                </p>
            </div>

            <div >
                <img class="qrcode-show" src="@/assets/images/download/qrcode.png" alt=""/>

                <p class="download-text">
                    扫描上方二维码下载<br>
                    博智林机器人联合APP
                </p>
            </div>
        </div>




      <div class="img-show">
        <div class="image-title">插件管理 轻松操控</div>
        <img class="mobile-size" src="@/assets/images/download/p1.png" alt=""/>

          <div class="image-title">一人轻松操控多个机器人</div>
        <img class="mobile-size" src="@/assets/images/download/p2.png" alt=""/>

          <div class="image-title">支持博智林公司的机器人插件</div>
        <img class="mobile-size" src="@/assets/images/download/p3.png" alt=""/>
      </div>

      <div class="text-right">
        <a href="https://www.bzlrobot.com/api/stl/actions/download?siteId=1&channelId=48&contentId=226&fileUrl=UaoGJXXz3xwwRAO8z0slash0Rg0slash08X0add0ksj5bO0slash0iaWWa0slash0GgsbRHKBBgEDq0add0OvkTfTjqdkH3j0secret0">
            <img  src="@/assets/images/download/file.png" alt=""/>博智林联合APP使用手册.PDF</a>
      </div>
    </div>


  </div>
</template>

<script>
export default {
    name: "download",
    data() {
        return {
            detail: {},
        }
    },
    created(){

    },
    methods: {

    }
}

</script>

<style scoped>
.introduce-page{
  padding-bottom: 0px;
}
.banner{
  width: 100%;
}
.title{
  height: 67px;
  font-size: 48px;
  font-weight: bold;
  color: #333333;
  line-height: 67px;
  margin-top: 100px;
  margin-bottom: 36px;
  text-align: center;
}
.main{
  padding: 0 48px;
}
.content{
  margin-bottom: 48px;
  font-size: 28px;
  font-weight: 400;
  color: #666666;
  line-height: 50px;
}
.download-page{
  text-align: center;
}
.mobile-size{
  padding-top: 30px;
  width: 80%;
}
.image-title{
    height: 40px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 80px;
    margin-top: 10px;
}
.img-show{
  padding-top: 0px;
}
.qrcode-show{
    width: 30%;
}
.text-right{
  margin: 40px auto;
  display: flex;
  width: 80%;
  align-items: center;
  justify-content: center;

}
.text-right img{
  height: 28px;
}
.download-btn{
  position: relative;
  z-index: 5;
  margin: 0 auto;
  width: 360px;
  height: 80px;
  font-family: PingFangSC, PingFangSC-Medium;
  background: #d75f9d;
  border-radius: 32px;
  text-align: center;
  color: #fff;
  line-height: 80px;
  font-size: 24px;
  cursor: pointer;
}
.download-text{
    font-size: 12px;
  padding: 10px 0;
    color: #888888;
}
</style>
